import { render, staticRenderFns } from "./ExpiredPassword.vue?vue&type=template&id=0bfef47d&scoped=true&"
import script from "./ExpiredPassword.vue?vue&type=script&lang=js&"
export * from "./ExpiredPassword.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredPassword.vue?vue&type=style&index=0&id=0bfef47d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfef47d",
  null
  
)

export default component.exports